export default __webpack_public_path__ + "static/media/UTM Bebas.49f17f3e.ttf";